import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/layout';
import Head from 'components/head';
import { Box, Heading, Text, Flex, AspectRatio } from '@chakra-ui/react';
import Proyectos from '../../components/proyectos';
import { VideoSchema } from 'helpers/schemaGenerator';
import ContactBanner from '../../components/contactBanner';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import ogImg from '../../../content/images/servicios/Animacion3D-Proyeccion-Mexico.jpg';

const Animacion = ({ lang='es' }) => {
  const l = (...texts) => lang === 'en' ? texts[1] : texts[0]
  const pageTitle = l('🏃‍♀️ Animación, modelado 3D y motion graphics', '🏃‍♀️ 3D Animation, 3D rendering y motion graphics')
  const pageImage =
    'https://visualma.com' + ogImg
  const pageDescription =
    l('Creamos animaciones impactantes y dinámicas para todo tipo de medios. Somos proveedores de animación 3D, Animación 2D y Motion graphics en México',
      'We create impressive and dynamic animations for all kinds of mediums. 3D animation, 2D animation and motion graphics')
  const pageUrl = l('https://visualma.com/animacion-modelado-3d', 'https://visualma.com/en/3d-animation')

  const MedImgProps = {
    layout: 'constrained',
    width: 800,
    height: 450,
    formats: ['auto', 'webp', 'avif'],
  }

  return (
    <Layout lang={lang}>
      <Head lang={lang}
        pageTitle={pageTitle}
        imageUrl={pageImage}
        pageDescription={pageDescription}
      />
      <VideoSchema
        videoUrl="https://www.youtube.com/embed/ia_ECuCeTRI"
        contentUrl={pageUrl}
        imageUrl={pageImage}
        title={pageTitle}
        description={
          l('Ejemplos de Animación 3D y Modelado 3D en México por la agencia Visualma',
            '3D Animation examples created by Visualma')
        }
        date="2020-07-09T22:46:01Z"
        duration="PT57S"
      />
      <div>
        {/* ----- HeroImage ----- */}
        <Flex justifyContent="flex-end">
          <h2 className="pageHeader">
            {l('Animación 3D', '3D Animation')}
          </h2>
        </Flex>

        <StaticImage
          className="headerImg"
          layout="fullWidth"
          formats={['auto', 'webp', 'avif']}
          loading="eager"
          src="../../../content/images/servicios/Animacion3D-Proyeccion-Mexico.jpg"
          alt={l('Animación 3D en México', '3D Animation')}
        />

        <Flex className="headerTitleWrapper">
          <div>
            <h1 className="parrafo parrafoGrande headerTitle">
              {l(<><b>Animación y Modelado 3D</b> en México</>,
                <b>3D Animation & Motion Graphics</b>)}
            </h1>
          </div>
        </Flex>
        {/* ----------------------- */}
          
        <p className="parrafo">
          {l('Animaciones de la mas alta calidad para todo tipo de medios, captura a tu audiencia con un contenido único y memorable que representa la esencia de tu marca.',
            'The highest quality 3D Animations for all kind of mediums. Capture your audience with unique and memorable content that represents the esscence of your brand.')}
        </p>

        <Box m="2em auto 0em" textAlign="center">
          <video
            controls={false}
            width="960px"
            loading="lazy"
            autoPlay
            loop
            playsInline
            muted
            controlsList="nodownload"
            crossOrigin="anonymous"
            alt={l('Video de Modelado 3D y animación de automóviles', 'Video of 3D modeling and Animation for cars')}
            title={l('Video de Modelado 3D y animación de automóviles', 'Video of 3D modeling and Animation for cars')}
            style={{ margin: '0 auto', maxWidth: '100%' }}
          >
            <source src="https://player.vimeo.com/external/465995256.hd.mp4?s=687adb7f53101419c5dd56324796993ad3ebaf99&profile_id=175"
              type="video/mp4"
            />
            Tu navegador no soporta videos.
          </video>
        </Box>

        <Box m="-3em auto 1em" textAlign="center">
          <video
            controls={false}
            width="960px"
            loading="lazy"
            autoPlay
            loop
            playsInline
            muted
            controlsList="nodownload"
            crossOrigin="anonymous"
            alt={l('Video de Modelado 3D y animación de automóviles', 'Video of 3D modeling and Animation for cars')}
            title={l('Video de Modelado 3D y animación de automóviles', 'Video of 3D modeling and Animation for cars')}
            style={{ margin: '0 auto', maxWidth: '100%' }}
          >
            <source src="https://player.vimeo.com/external/400463687.hd.mp4?s=d33c5b82a5127fe16508050be3a506a04957c17d&profile_id=175"
              type="video/mp4"
            />
            Tu navegador no soporta videos.
          </video>
        </Box>

        <div className="contenido" style={{ marginTop: '4em', marginBottom: '0em', maxWidth: '40em', fontSize: '1.3em'}}>
          <Heading as="h3" className="subHeader subHeaderSmall" mb="0em">
            {l('Animación 3D y motion graphics', '3D Animation and motion graphics')}
          </Heading>
        </div>
        <p className="parrafo">
          {l('Generamos contenidos impactantes y dinámicos combinando técnicas de animación en tercera dimension, modelado, guionado, ilustración y motion graphics.',
            'We create impactful content combining 3D animation techniques, 3D modeling, storyboarding, illustration and motion graphics.')}
        </p>

        <AspectRatio
          maxWidth="55em"
          style={{ margin: '0 auto 2em' }}
          ratio={21 / 10}
        >
          <Box
            style={{
              width: '100%',
              minHeight: '260px',
            }}
            as="iframe"
            loading="lazy"
            title={l('Animación y modelado 3D en México', '3D Animation and modeling by visualma')}
            src={
              'https://www.youtube.com/embed/ia_ECuCeTRI?vq=hd1080&modestbranding=1&color=red&iv_load_policy=3&rel=0'
            }
            allowFullScreen
            borderRadius={[0, 0, 0, '8px']}
            margin={['4em auto 2em', '0em auto 2em']}
          />
        </AspectRatio>

        <p className="parrafo">
          {l('Nuestra especialidad es generar piezas únicas para campañas publicitarias, eventos de activación, convenciones y eventos integrando una gran variedad de contenido para impactar al espectador y transmitir sensaciones vívidas mediante una gran historia y un contenido audiovisual espectacular.',
            'Our specialty is to generate unique content for marketing campaigns, product launches, corporate conventions and events, integrating a great variety of content to impact the audience and transmit vivid sensations with a great story and espectacular visual content.')}
        </p>

        {/* // TODO ¿Poner estas imágenes? */}
        {/* <Box
          style={{
            margin: '-3em auto 2em',
            width: '100%',
            maxWidth: '60em',
          }}
        >
          <div className='iconList iconListSmallOnMobile'>
            <div>
              <StaticImage {...MedImgProps}
                src={imgAnim2}
                style={{ maxHeight: '330px', margin: '0 auto' }}
                alt="Nave espacial de juguete modelada para animación 3D y videojuegos"
              />
            </div>
            <div>
              <StaticImage {...MedImgProps}
                src={imgAnim3}
                style={{ maxHeight: '330px', margin: '0 auto' }}
                alt="Soldado del juego Destiny modelado para video animado en 3D"
              />
            </div>
          </div>
        </Box> */}

        <Flex className="flexList" style={{ maxWidth: '60em'}}>
          <Flex className="columna">
            <Heading as="h3">
              {l('Comerciales de TV', 'TV Ads')}
            </Heading>
            <Text fontSize="xl" className="parrafoChico">
              {l('Ofrecemos la calidad necesaria para que tu producto sobresalga entre el ruido mediático y capture la imaginación de los espectadores.',
                'We offer the quality necesary to make your product stand out among all the mediatic noise and capture the imagination of your audience.')}
            </Text>
          </Flex>
          <Flex className="columna">
            <Heading as="h3">
              {l('Comunicación Corporativa', 'Corporate communication')}
            </Heading>
            <Text fontSize="xl" className="parrafoChico">
              {l('Explica de manera clara y atractiva tu nuevo producto, demuestra tu propuesta de valor a clientes e inversionistas.',
                'Explain your product and show your value proposition to clients and investors in a clear and attractive way.')}
            </Text>
          </Flex>

          <Flex className="columna">
            <Heading as="h3">
              {l('Brand Idents', 'Brand Idents')}
            </Heading>
            <Text fontSize="xl" className="parrafoChico">
               {l('Paquetería gráfica animada que representa a tu marca, producto o evento de manera atractiva y moderna en todo tipo de medios.',
                'Attractive animated graphics that represent your brand, product or event in every kind of medium.')}
            </Text>
          </Flex>
          <Flex className="columna">
            <Heading as="h3">
              {l('Escenarios virtuales', 'Virtual Production')}
            </Heading>
            <Text fontSize="xl" className="parrafoChico">
              {l('Escenarios virtuales y grabaciónes en green screen con tracking 3D con los que podrás transmitir en vivo desde escenarios inimaginables. ',
                'Virtual sets and green screen productions with 3D motion tracking that allow you to broadcast live from incredible sceneries.')}
            </Text>
          </Flex>

          <Flex className="columna">
            <Heading as="h3">
              {l('Series Animadas / Personajes', 'Animated series')}
            </Heading>
            <Text fontSize="xl" className="parrafoChico">
              {l('Te ayudamos a crear tu serie animada, desde una introducción hasta un mundo completo lleno de personajes, historias y episodios.',
                'We help you create your animated series, from an incredible intro to a world full of characters, stories and episodes.')}
            </Text>
          </Flex>
          <Flex className="columna">
            <Heading as="h3">
              {l('Redes Sociales', 'Social Networks')}
            </Heading>
            <Text fontSize="xl" className="parrafoChico">
              {l('Crea campañas animadas atractivas y modernas que generan un alto impacto en redes y logran un gran numero de interacciónes y views orgánicos.',
                'Create attractive and modern animated campaigns that generate a high impact in social networks and achieve a great number of interactions and organic views.')}
              <br />
              <br />
            </Text>
          </Flex>
        </Flex>

        <ContactBanner lang={lang}/>

        <AspectRatio
          maxWidth="60em"
          style={{ margin: '0 auto' }}
          ratio={21 / 10}
        >
          <Box
            style={{
              margin: '0em auto 2em',
              width: '100%',
              minHeight: '260px',
            }}
            as="iframe"
            loading="lazy"
            title="Animación y modelado 3D en México"
            src={
              'https://www.youtube.com/embed/kSHI08kNrIA?vq=hd1080&modestbranding=1&color=red&iv_load_policy=3&rel=0'
            }
            allowFullScreen
            borderRadius={[0, 0, 0, '8px']}
          />
        </AspectRatio>

        <Flex
          bg="transparent"
          justify="flex-start"
          direction="column"
          m="5em auto 1em"
        >
          <Heading as="h2" className="subHeader" mb="2em">
            {l('Modelado 3D', '3D Modeling')}
          </Heading>
          <Text fontSize="xl" className="parrafoChico">
            {l('El modelado 3D permite realizar representaciones virtuales de cualquier superficie o objeto mediante un sistema de cordenadas matematicas en tres dimensiones.',
              '3D Modeling allows for the creation of a digital representation of any surface or object with the use of a mathematical coordinate system in three dimensions.')}
          </Text>
          <Box
            style={{
              margin: '2em auto 3em',
              width: '100%',
              maxWidth: '60em',
              textAlign: 'center'
            }}
          >
            <StaticImage
              {...MedImgProps}
              src="../../../content/images/servicios/animacion/proceso-modelado-3d-coche-hotwheels-twinmill_comp.jpg" alt='Proceso de modelado 3D y texturizado de coche de hotwheels' />
          </Box>
          <Text fontSize="xl" className="parrafoChico spacer">
            {l('Usando todo tipo de técnicas de manipulación de polígonos, escultura digital, fotogrametría y programación procedural nuestra finalidad es tener el modelo más preciso para integrarlo a un mundo digital donde cobrará vida.',
              'Using poligon manipulation techniques, digital sculpting, photogrammetry and procedural programming our goal is to have the most precise model and integrate it to a virtual world where it is brought to life.')}
          </Text>
        </Flex>

        <Box m="o auto" textAlign="center">
          <video
            controls={false}
            width="960px"
            loading="lazy"
            autoPlay
            loop
            playsInline
            muted
            controlsList="nodownload"
            crossOrigin="anonymous"
            alt="Video de lentes de Realidad virtual y ecenarios 3d"
            title="Video de lentes de Realidad virtual y ecenarios 3d"
            style={{ margin: '0 auto', maxWidth: '100%' }}
          >
            <source src="https://player.vimeo.com/external/465908903.hd.mp4?s=ab12d205bf21f331599a050a741340dd192f098f&profile_id=175"
              type="video/mp4"
            />
            Tu navegador no soporta videos.
          </video>
        </Box>

        <Proyectos lang={lang}
          title={l('Nuestros proyectos de Animación y Modelado 3D', '3D Animation & modeling examples')}
          category="Animación y Modelado 3D"
          limit={3}
        />

        <Flex
          bg="transparent"
          justify="flex-start"
          direction="column"
          m="4em auto 1em"
        >
          <Heading as="h2" className="subHeader" mb="2em">
            {l('Técnicas avanzadas de modelado', 'Advanced 3D modeling techniques')}
          </Heading>
          <Text fontSize="xl" className="parrafoChico spacer">
            {l(<>
              Existen diferentes técnicas para lograr representaciones en 3D fotorrealistas con proporciónes a escala real y una presición milimetrica.
              <br />
              Con el uso de fotografías en alta resolución, sensores LIDAR (Light Detection and Ranging o Laser Imaging Detection and Ranging) y drones somos capaces de reproducir cualquier objeto, producto, fachada, edificio o escenario mediante técnicas de fotogrametría.
              <br /><br />
              Este proceso de modelado es ideal para proyectos de{' '} 
              <Link style={{textDecoration: 'underline', textDecorationColor: '#666'}} to="/arquitectura-recorrido-virtual">visualización arquitectónica y recorridos virtuales 360º</Link>,{' '}
              <Link style={{textDecoration: 'underline', textDecorationColor: '#666'}} to="/realidad-virtual">Realidad Virtual</Link>
              , reproducción de espacios históricos comúnmente usados en{' '}
              <Link style={{ textDecoration: 'underline', textDecorationColor: '#666' }} to="/museos-instalaciones">proyectos museográficos</Link>{' '}
              , catálogos de esculturas y productos en{' '}
              <Link style={{textDecoration: 'underline', textDecorationColor: '#666'}} to="/realidad-aumentada">realidad aumentada</Link>.
            </>,
            <>
              There are different techniques to get photorealistic 3D representations with real scale proportions and millimetric precision.
              <br />
              With the use of high resolution images, LIDAR (Light Detection and Ranging o Laser Imaging Detection and Ranging) sensors and drones we are capable to reproduce every object, product, building or scenery with the use of photogrammetry.
              <br /><br />
              Este proceso de modelado es ideal para proyectos de
              
              This 3D modeling process is ideal for{' '}
              <Link style={{ textDecoration: 'underline', textDecorationColor: '#666' }} to="/en/architecture-virtual-tours">architectonic visualizations and virtual tours 360º</Link>,{' '}
              <Link style={{ textDecoration: 'underline', textDecorationColor: '#666' }} to="/en/virtual-reality">Virtual Reality</Link>
              , historic site reproduction and historic characters used in {' '}
              <Link style={{ textDecoration: 'underline', textDecorationColor: '#666' }} to="/en/interactive-museums">museographic projects</Link>{' '}
              , art catalogs and products in{' '}
              <Link style={{ textDecoration: 'underline', textDecorationColor: '#666' }} to="/en/augmented-reality">augmented reality</Link> projects.
            </>)}
          </Text>

          <Box
            style={{
              margin: '1em auto 2em',
              width: '100%',
              maxWidth: '60em',
            }}
          >
            <div className='iconList'>
              <div style={{flexBasis: '600px', maxWidth: '400px', margin: '0 auto'}}>
                <StaticImage {...MedImgProps}
                  src="../../../content/images/servicios/animacion/texturizado-zapato-3d-adidasZx3_comp.jpg"
                  style={{ margin: '0 auto' }}
                  alt="Modelo 3D de zapato marca Adidas modelo ZX naranja"
                />
              </div>
              <div style={{flexBasis: '600px', maxWidth: '400px', margin: '0 auto'}}>
                <StaticImage {...MedImgProps}
                  src="../../../content/images/servicios/animacion/modelado3d-zapato-AdidasZX_comp.jpg"
                  style={{ margin: '0 auto' }}
                  alt="Modelo 3D de zapato marca Adidas modelo ZX naranja"
                />
              </div>
            </div>
          </Box>
        </Flex>

        <Flex
          bg="transparent"
          justify="flex-start"
          direction="column"
          m="3em auto"
        >
          <Heading as="h2" className="subHeader" mb="2em">
            {l('Captura de movimiento', 'Motion Capture')}
          </Heading>
          <Text fontSize="xl" className="parrafoChico spacer">
            {l(<>
              La animación tradicional es esencial para una gran variedad de proyectos, por otro lado, existen proyectos con una exigencia diferente donde se busca reproducir movimientos exactos a como los haría una persona.En estos casos incorporamos a nuestros procesos la Captura por Movimiento o Motion Capture (Mocap).
              <br /><br />
              Este proceso se realiza mediante un grupo de cámaras y sensores en un espacio destinado únicamente a capturar el movimiento de un actor, para posteriormente procesar y filtrar toda esa información generando una animacion totalmente realista para un personaje que existirá en un ambiente virtual.
              <br /><br />
              Las técnicas de captura de movimiento facial nos permiten animar personajes que transmiten emociones y se comunican con expresiones realistas.
            </>,
            <>
              Traditional animation is escential to a great variety of projects, on the other hand, some projects have needs that demand the reproduction of movements in exactly the way a person would. In this case we incorporate Motion Capture (Mocap) to our process.
              <br /><br />
              This process is realized with the use of cameras and sensors destined to capture the movement of an actor in 3D and his face gestures.
              After processing the captured information we generate a realistic animation that can be used in a virtual 3D character.
              <br /><br />
              Facial motion capture techniques allow us to animate characters that transmit emotions and communicate with realistic expressions.
            </>)}
          </Text>
        </Flex>

        <Box
          style={{
            margin: '1em auto 2em',
            width: '100%',
            maxWidth: '60em',
          }}
        >
          <div className='iconList iconListSmallOnMobile'>
            <div>
              <StaticImage {...MedImgProps} src="../../../content/images/servicios/animacion/modelado-3D-personajes-Blastoise_color.jpg" alt="Modelado y animación 3d de personaje azul blastoise en wireframe" />
            </div>
            <div>
              <StaticImage {...MedImgProps} src="../../../content/images/servicios/animacion/modelado-3D-personajes-Blastoise_wireframe.jpg" alt="Modelado y animación 3d de personaje azul blastoise a color" />
            </div>
            <div>
              <StaticImage {...MedImgProps} src="../../../content/images/servicios/animacion/modelado-3D-personajes-pikachu.jpg" alt="Modelado y animación 3d de personaje pikachu en wireframe" />
            </div>
            <div>
              <StaticImage {...MedImgProps} src="../../../content/images/servicios/animacion/modelado-3D-personajes-pikachu_wireframe.jpg" alt="Modelado y animación 3d de personaje pikachu a color" />
            </div>
          </div>
        </Box>

        <ContactBanner lang={lang}/>

      </div>
    </Layout>
  );
};
Animacion.propTypes = {
  lang: PropTypes.string,
};

export default Animacion;
